import { render } from "./DashboardCommunityDataCard.vue?vue&type=template&id=1bde8481"
import script from "./DashboardCommunityDataCard.vue?vue&type=script&lang=js"
export * from "./DashboardCommunityDataCard.vue?vue&type=script&lang=js"

import "./DashboardCommunityDataCard.vue?vue&type=style&index=0&id=1bde8481&lang=css"
script.render = render

export default script